import createDataContext from "./createDataContext";
import { isWithinInterval, format } from "date-fns";

var axios = require("axios");
var qs = require("qs");

const reducer = (state, action) => {
  switch (action.type) {
    case "update_history":
      return {
        ...state,
        payments: action.payload,
      };
    default:
      return state;
  }
};

const getPayments = (dispatch) => async ({ startDate, endDate, paymentId }) => {
  function createData(
    paymentID,
    status,
    paymentDate,
    invoices,
    description,
    amount,
    fee,
    paymentMethod,
    pdfLink
  ) {
    return {
      paymentID,
      status,
      paymentDate,
      invoices,
      description,
      amount,
      fee,
      paymentMethod,
      pdfLink,
    };
  }

  try {
    const response = await axios({
      method: "post",
      data: qs.stringify({
        method: "getPayments",
      }),
      withCredentials: true,
    });

    console.log("PAYMENT HISTORY", response.data);
    let payments = response.data.payments;
    let sortedPayments = payments.sort((a, b) => a.paymentID - b.paymentID);

    let tempRows = [];

    function getStatusCode(code) {
      switch (code) {
        case 5:
          return "Complete";
        case 0:
          return "Queueing";
        case 1:
          return "Queued";
        case 2:
          return "Pending";
      }
    }

    Object.keys(sortedPayments).map((payment) => {
      const tempPayment = response.data.payments[payment];

      function correctDate(d) {
        let date = new Date(d);
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      }

      function getStartDate(d) {
        let date = new Date(d);
        return date.setHours(0, 0, 0, 0);
      }

      function getEndDate(d) {
        let date = new Date(d);
        return date.setHours(23, 59, 59, 999);
      }

      const data = createData(
        tempPayment.paymentID,
        getStatusCode(tempPayment.status),
        format(correctDate(tempPayment.paymentDate), "MM/dd/yyyy"),
        tempPayment.invoices,
        tempPayment.description,
        parseFloat(tempPayment.amount).toFixed(2),
        tempPayment.feeAmount,
        {
          paymentMethod: tempPayment.paymentMethod,
          paymentLastFour: tempPayment.paymentLastFour,
        }
      );

      if (paymentId) {
        console.log(paymentId);
        if (paymentId === tempPayment.paymentID.toString()) {
          tempRows.push(data);
        }
      } else {
        // console.log("DATE", new Date(correctDate(tempPayment.paymentDate)));
        // console.log("Start Date", new Date(startDate));
        // console.log("End Date", new Date(endDate));
        if (
          isWithinInterval(new Date(correctDate(tempPayment.paymentDate)), {
            start: new Date(getStartDate(startDate)),
            end: new Date(getEndDate(endDate)),
          })
        ) {
          tempRows.push(data);
        }
      }
    });

    console.log("Temp ROWS HISTORY", tempRows);

    dispatch({
      type: "update_history",
      payload: tempRows.reverse(),
    });
  } catch {
    console.log("ERrrrrror getting invoices");
  }
};

export const { Provider, Context } = createDataContext(
  reducer,
  {
    getPayments,
  },
  {
    payments: [],
  }
);
